import { combineReducers } from 'redux';
import ActionTypes from './../common/ActionTypes';
import uiState from './uiState';
import user from './user';
import workLogsToday from './workLogsToday';
import history from './history';
import projects from './projects';
import projectDetails from './projectDetails';
import listMode from './listMode';

const appReducer = combineReducers({
  uiState,
  user,
  workLogsToday,
  history,
  projects,
  projectDetails,
  listMode,
});

const rootReducer = (state, action) => {
  const newState =
    action.type === ActionTypes.CLEAR_ALL ? appReducer({}, {}) : state;
  return appReducer(newState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js